import { z } from 'zod';

/////////////////////////////////////////
// VIOLATION TYPE SCHEMA
/////////////////////////////////////////

export const ViolationTypeSchema = z.object({
  violationtypeId: z.number().int(),
  cityId: z.number().int(),
  violationtag: z.string(),
  violationname: z.string(),
  violationcode: z.string(),
  violationtext: z.string(),
  violationtext2: z.string(),
  displayGroupId: z.number().int(),
  displayOrder: z.number().int(),
  deleted: z.number().int(),
})

export type ViolationType = z.infer<typeof ViolationTypeSchema>

export default ViolationTypeSchema;
